import { apiCall } from './gqlClient';

const NUTRITIONMICROCYCLES_QUERY = `
  query nutritionMicrocycles($providerId: Float!) {
    nutritionMicrocycles(providerId: $providerId)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			coverUrl
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const nutritionMicrocyclesApiCall = async ({providerId}, fragments = null) => apiCall({ query: NUTRITIONMICROCYCLES_QUERY, variables: {providerId}, fragments });

const NUTRITIONMICROCYCLE_QUERY = `
  query nutritionMicrocycle($id: String!) {
    nutritionMicrocycle(id: $id)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			coverUrl
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const nutritionMicrocycleApiCall = async ({id}, fragments = null) => apiCall({ query: NUTRITIONMICROCYCLE_QUERY, variables: {id}, fragments });

const CREATENUTRITIONMICROCYCLE_QUERY = `
  mutation createNutritionMicrocycle($input: NutritionMicrocycleInput!) {
    createNutritionMicrocycle(input: $input)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			coverUrl
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const createNutritionMicrocycleApiCall = async ({input}, fragments = null) => apiCall({ query: CREATENUTRITIONMICROCYCLE_QUERY, variables: {input}, fragments });

const UPDATENUTRITIONMICROCYCLE_QUERY = `
  mutation updateNutritionMicrocycle($id: String!, $input: NutritionMicrocycleInput!) {
    updateNutritionMicrocycle(id: $id, input: $input)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			coverUrl
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const updateNutritionMicrocycleApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATENUTRITIONMICROCYCLE_QUERY, variables: {id, input}, fragments });

const DELETENUTRITIONMICROCYCLE_QUERY = `
  mutation deleteNutritionMicrocycle($id: String!) {
    deleteNutritionMicrocycle(id: $id)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			coverUrl
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const deleteNutritionMicrocycleApiCall = async ({id}, fragments = null) => apiCall({ query: DELETENUTRITIONMICROCYCLE_QUERY, variables: {id}, fragments });
